<template>
  <div id="news-wrap">
    <div class="news-slider-wrap" >
      <div class="news-slider-text-wrap" >
        <div class="news-slider-text" :style="{width: `${100 * $t('message.news').length}%`, transform: `translateX(-${(100/$t('message.news').length) * this.index}%)`}">
          <div v-for="(news, index) in $t('message.news') " :key="index">
            <SlideNews 
              :obj="news" 
              @toggleOpenOverlay="toggleOpenOverlay(index)" 
              :index="index"
            />
          </div>
        </div>
      </div>
      <div class="news-slider-images-wrap" >
        <div class="news-slider-image" :style="{height: `${100 * $t('message.news').length}%`, transform: `translateY(-${(100/$t('message.news').length) * this.index}%)`}">
          <div v-for="(news, index) in $t('message.news') " :key="index">
            <SlideNewsImage :img="require('../../assets/images/' +news.imagesrc)" />
          </div>
        </div>
      </div>
    </div>
    <div class="buttons-wrap" :style="{ display: $t('message.news').length > 1 ? 'flex' : 'none' }">
      <div class="button button-prev" @click="sliderBtn(-1)">
        <img src="../../assets/images/arrow-prev@2x.png" />
      </div>
      <div class="button button-next" @click="sliderBtn(1)">
        <img src="../../assets/images/arrow-next@2x.png" />
      </div>
    </div>
  </div>
</template>

<script>
import SlideNews from './SlideNews.vue'
import SlideNewsImage from './SlideNewsImage.vue'

export default {
  name: 'News',
  props:['toggleOpenOverlay'],
  data(){
    return {
      index: 0
    }
  },
  components: {
    SlideNews,
    SlideNewsImage
  },
  methods: {
    sliderBtn(dir){
      let index = ((this.index + dir) < 0) ? 0 : dir;
      index = (this.index + index > this.$t('message.news').length - 1) ? 0 : index;
      this.index += index;      
    },
    
  }
}
</script>

<style lang="scss" scoped>
  #news-wrap{
    position: relative;
    z-index: 1;
    height: 265px;
    margin: 180px 25% 0;
    box-shadow: 0 0 10px 5px rgba($color: #000000, $alpha: 0.1);
    background-color: #fff;
    @media screen and( max-width: 1100px) {
      margin: 150px 15% 0;
    }
    @media screen and( max-width: 900px) {
      margin: 100px 20px 0;
      height: auto;
    }
    
  }
  .buttons-wrap{
    position: absolute;
    z-index: 2;
    bottom: 0;
    right: 0;
    width: 108px;
    height: 54px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .button{
      position: relative;
      width: 54px;
      height: 54px;
      cursor: pointer;
      img{
        display: block;
        width: 100%;
      }
    }
  }
  .news-slider-wrap{
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    @media screen and( max-width: 900px) {
      flex-direction: column-reverse;
    }
    .news-slider-text-wrap{
      position: relative;
      overflow: hidden;
      height: 100%;
      width: auto;
      flex: 1 1 auto;
      .news-slider-text{
        position: relative;
        display: flex;
        flex-direction: row;
        transform: translateX(0);
        transition: transform .5s ease-out;
        >div{
          height: 265px;
          width: 100%;
        }
      }
    }
    .news-slider-images-wrap{
      position: relative;
      overflow: hidden;
      height: 100%;
      width: 265px;
      flex: 1 0 265px;
      @media screen and( max-width: 900px) {
        width: 100%;
        height: 140px;
        flex: 1 0 auto;
      }
      .news-slider-image{
        position: relative;
        display: flex;
        flex-direction: column;
        transform: translateY(0);
        transition: transform .5s ease-out .01s;
        >div{
          width: 100%;
          overflow: hidden;
          @media screen and( max-width: 900px) {
            height: 140px;
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// News.vue?6474807e